import { GetAccountTopAppsMetricsSummary } from '../../../../src/interface/dtos/top-apps/get-account-top-apps-metrics-summary.response.dto';
import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDuration } from '../../../common/utils/format-duration.util';
import { AccountTopAppsMetricsSummaryAggregateRoot } from '../../../../src/core/domain/aggregates/top-apps/account-top-apps-metrics-summary.aggregate-root';
import { formatPrice } from '../../../../src/common/utils/format-price';
import { formatDeviationPrefix } from '../../../../src/common/utils/format-deviation.util';
import { MetricValueType } from '../../../interface/dtos';

export type IAccountTopAppsMetricsSummaryAggregateRootMapper = Mapper<
  AccountTopAppsMetricsSummaryAggregateRoot,
  GetAccountTopAppsMetricsSummary
>;

export class AccountTopAppsMetricsSummaryAggregateRootMapper
  implements Omit<IAccountTopAppsMetricsSummaryAggregateRootMapper, 'toDomain'>
{
  toResponse(
    entity: AccountTopAppsMetricsSummaryAggregateRoot
  ): GetAccountTopAppsMetricsSummary {
    return AccountTopAppsMetricsSummaryAggregateRootMapper.toResponse(entity);
  }

  static toResponse(
    entity: AccountTopAppsMetricsSummaryAggregateRoot
  ): GetAccountTopAppsMetricsSummary {
    return {
      totalCost: formatPrice(entity.totalCost),
      averageCost: formatPrice(entity.averageCost),
      userCount: entity.userCount,
      appId: entity.appId,
      totalViews: formatDuration(entity.totalViews),
      averageViews: formatDuration(entity.averageViews),
      totalCostDeviation: `${formatDeviationPrefix(
        entity.totalCostDeviation
      )}${formatPrice(entity.totalCostDeviation)}`,
      averageCostDeviation: `${formatDeviationPrefix(
        entity.averageCostDeviation
      )}${formatPrice(entity.averageCostDeviation)}`,
      totalViewsDeviation: formatDuration(entity.totalViewsDeviation),
      averageViewsDeviation: formatDuration(entity.averageViewsDeviation),
      averageInteractions: String(entity.averageCount),
      averageInteractionsDeviation: String(entity.averageCountDeviation),
      averageUsers: String(entity.userCount),
      totalInteractions: String(entity.totalCount),
      totalInteractionsDeviation: String(entity.totalCountDeviation),
      userDeviation: String(entity.userDeviation),
    };
  }
}
